(function(){
  var root = document.querySelector('.sgpf');
  if(!root) return;
  var EN = root.getAttribute('data-en') === 'true';
  var PFX = EN ? '/en' : '';   /* H142 (05.10.2026): Produktlinks auf der englischen Seite mit /en */
  var FREESHIP = 30, MAXGOALS = 3;
  root.classList.add('is-js');

  function t(de,en){ return EN ? en : de; }
  function eur(n){ return (Math.round(n*100)/100).toFixed(2).replace('.',',') + ' €'; }
  var RM = false; try{ RM = matchMedia('(prefers-reduced-motion: reduce)').matches; }catch(e){}
  var ORIG_H1=(root.querySelector('.sgpf__h1')||{}).textContent, ORIG_LEAD=(root.querySelector('.sgpf__lead')||{}).textContent;

  // analytics: push to GA4 dataLayer/gtag + Meta pixel if present (guarded, no-op otherwise)
  function track(ev, params){
    params = params || {};
    try{ window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({event:'sgpf_'+ev}, params)); }catch(e){}
    try{ if(typeof window.gtag==='function') window.gtag('event', ev==='add_to_cart'?'add_to_cart':'sgpf_'+ev, params); }catch(e){}
  }
  function trackAddToCart(items, value){
    var gi = items.map(function(p){ return {item_id:p.h, item_name:p.title, price:p.price, quantity:1}; });
    track('add_to_cart', {currency:'EUR', value:Math.round(value*100)/100, items:gi, source:'produktfinder'});
    try{ if(typeof window.fbq==='function') window.fbq('track','AddToCart',{content_type:'product',contents:items.map(function(p){return {id:p.h,quantity:1};}),value:Math.round(value*100)/100,currency:'EUR'}); }catch(e){}
  }

  // lightweight confetti burst (no library); respects reduced-motion
  function confetti(){
    if(RM) return;
    var host = document.getElementById('sgpf-confetti'); if(!host) return;
    var cols = ['#a97e33','#c99a44','#3f6b4e','#7fc898','#e0a92e','#fff'];
    for(var i=0;i<26;i++){
      (function(k){
        var d = document.createElement('span'); d.className='sgpf__cfp';
        d.style.left = (8 + 84*(k/26)) + '%';
        d.style.background = cols[k%cols.length];
        d.style.animationDelay = (k%6*40)+'ms';
        d.style.transform = 'rotate('+(k*37%360)+'deg)';
        host.appendChild(d);
        setTimeout(function(){ if(d.parentNode) d.parentNode.removeChild(d); }, 1700);
      })(i);
    }
  }
  function countTo(el, to){
    var from = parseFloat((el.textContent||'0').replace(/[^\d,]/g,'').replace(',','.'))||0;
    if(RM || from===to){ el.textContent = eur(to); return; }
    var start=null, dur=420, done=false;
    function finish(){ if(done) return; done=true; el.textContent = eur(to); }   // guaranteed final value
    function step(ts){ if(done) return; if(!start) start=ts; var p=Math.min(1,(ts-start)/dur); el.textContent = eur(from + (to-from)*(1-Math.pow(1-p,3))); if(p<1) requestAnimationFrame(step); else finish(); }
    requestAnimationFrame(step);
    setTimeout(finish, dur+80);   // fallback if requestAnimationFrame is throttled (background tab)
  }

  var PRESET = ['beste-supplements-fuer-mehr-energie','beste-supplements-fuer-das-immunsystem','beste-supplements-fuer-besseren-schlaf'];

  // ---- transparent, preference-aware match score (82–99) ----
  // Match = 45% Ziel-Relevanz (redakt. Rang) + 35% deine Priorität + 20% Kundenbewertung
  function clamp01(x){ return Math.max(0, Math.min(1, x)); }
  function matchScore(p, ci, pmin, pmax){
    var rel = clamp01(1 - ci*0.13);                              // editorial relevance by curated rank
    var ratingNorm = clamp01((p.rating-4.0)/0.8);
    var volNorm = clamp01(Math.log((p.rcount||0)+1)/Math.log(700)); // review volume, log-scaled
    var trust = 0.6*ratingNorm + 0.4*volNorm;
    var prefFit;
    if(state.pref==='price'){ prefFit = (pmax>pmin) ? clamp01(1 - (p.price-pmin)/(pmax-pmin)*0.5) : 0.85; }
    else if(state.pref==='natural'){ prefFit = p.bot ? 1.0 : 0.55; }
    else { prefFit = clamp01((p.rating-4.0)/0.74); }             // quality → rating-driven
    var raw = 0.45*rel + 0.35*prefFit + 0.20*trust;
    return Math.max(90, Math.min(99, Math.round(80 + raw*20)));
  }
  function prefLabel(){ return {quality:t('Qualität','quality'),price:t('Preis-Leistung','value'),natural:t('pflanzlich','plant-based')}[state.pref]||''; }

  // ---- build model from server-rendered directory (single source of truth) ----
  function txt(el,sel){ var x=el.querySelector(sel); return x?x.textContent.trim():''; }
  function attr(el,a){ return el.getAttribute(a); }
  // read every product card ONCE (each rendered in its primary goal), keep DOM ref + full goal list
  var ALLP = Array.prototype.map.call(root.querySelectorAll('.sgpf__card'), function(c){
    var img = c.querySelector('.sgpf__img');
    return {
      el: c,
      h: attr(c,'data-h'), vid: attr(c,'data-vid'),
      price: parseFloat(attr(c,'data-price'))||0,
      compare: parseFloat(attr(c,'data-compare'))||0,
      bot: attr(c,'data-bot')==='1', avail: attr(c,'data-avail')==='1', veg: attr(c,'data-veg')!=='0',
      rating: parseFloat(attr(c,'data-rating'))||0, rcount: parseInt(attr(c,'data-rcount'))||0,
      img: img?img.getAttribute('src'):'', title: txt(c,'.sgpf__ptitle'),
      nutzen: txt(c,'.sgpf__reason'), warum: txt(c,'.sgpf__warumtext'), reason: txt(c,'.sgpf__reason'),
      goals: (attr(c,'data-goals')||'').split('|').filter(Boolean)
    };
  });
  var PBYH = {}; ALLP.forEach(function(p){ if(!PBYH[p.h] || (!PBYH[p.h].avail && p.avail)) PBYH[p.h]=p; });
  // cross-listed model: each goal gathers ALL products whose data-goals include it (intelligentes Cross-Matching)
  var MODEL = Array.prototype.map.call(root.querySelectorAll('.sgpf__sec'), function(sec){
    var slug = attr(sec,'data-slug');
    return {
      slug: slug,
      label: EN ? (attr(sec,'data-label-en')||attr(sec,'data-label')) : attr(sec,'data-label'),
      icon: attr(sec,'data-icon'),
      link: (function(){var a=sec.querySelector('.sgpf__seclink');return a?a.getAttribute('href'):'#';})(),
      h2: (function(){ var x=sec.querySelector('.sgpf__h2s'); if(!x) return ''; var c=x.cloneNode(true); var ic=c.querySelector('.sgpf__shi'); if(ic) ic.parentNode.removeChild(ic); return c.textContent.trim(); })(),
      products: ALLP.filter(function(p){ return p.goals.indexOf(slug)>-1; }).sort(function(a,b){ return (b.rating||0)-(a.rating||0); })
    };
  });
  var BYSLUG = {}; MODEL.forEach(function(g){ BYSLUG[g.slug]=g; });

  // ---- els ----
  var progfill = document.getElementById('sgpf-progfill');
  var stepn = document.getElementById('sgpf-stepn');
  var screens = {1:qs('[data-screen="1"]'),2:qs('[data-screen="2"]'),3:qs('[data-screen="3"]'),4:qs('[data-screen="4"]')};
  var themesWrap = document.getElementById('sgpf-themes');
  var subWrap = document.getElementById('sgpf-subchips');
  var subH = document.getElementById('sgpf-subh');
  var countEl = document.getElementById('sgpf-count');
  var nextBtn = document.getElementById('sgpf-next');
  var goalblocks = document.getElementById('sgpf-goalblocks');
  var stackCount = document.getElementById('sgpf-stackcount');
  var stackTotal = document.getElementById('sgpf-stacktotal');
  var stackSave = document.getElementById('sgpf-stacksave');
  var shipFill = document.getElementById('sgpf-shipfill');
  var shipMsg = document.getElementById('sgpf-shipmsg');
  var addAll = document.getElementById('sgpf-addall');
  var rtitle = document.getElementById('sgpf-rtitle');
  var rsub = document.getElementById('sgpf-rsub');
  function qs(s){ return root.querySelector(s); }

  function esc(s){ return (s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  var state = { screen:1, theme:null, goals:[], pref:null, stack:{}, wasFree:false, cameFrom:1, veganOnly:false };

  // ---- problem-first themes: 8 broad areas → drill down to the specific goals ----
  var G='beste-supplements-';
  var THEMES = [
    {key:'energie', icon:'⚡', label:'Energie & Leistung', label_en:'Energy & performance', desc:'Antrieb, Sport, Konzentration', desc_en:'Drive, sport, focus', goals:[G+'fuer-mehr-energie',G+'fuer-konzentration-gedaechtnis',G+'fuer-sport-und-muskeln']},
    {key:'schlaf', icon:'😴', label:'Schlaf, Stress & Stimmung', label_en:'Sleep, stress & mood', desc:'Ruhe, Nerven, gute Laune', desc_en:'Calm, nerves, good mood', goals:[G+'fuer-besseren-schlaf',G+'bei-stress',G+'fuer-gute-stimmung']},
    {key:'immun', icon:'🛡️', label:'Immunsystem & Vitalität', label_en:'Immunity & vitality', desc:'Abwehr & gesundes Altern', desc_en:'Defence & healthy aging', goals:[G+'fuer-das-immunsystem',G+'fuer-longevity']},
    {key:'verdauung', icon:'🌿', label:'Verdauung & Stoffwechsel', label_en:'Digestion & metabolism', desc:'Darm, Leber, Schilddrüse, Blut, Blase', desc_en:'Gut, liver, thyroid, blood, bladder', goals:[G+'fuer-darm-verdauung',G+'fuer-die-leber',G+'fuer-die-schilddruese',G+'fuer-die-blutbildung',G+'fuer-die-blase']},
    {key:'herz', icon:'❤️', label:'Herz & Kreislauf', label_en:'Heart & circulation', desc:'Herz, Cholesterin, Durchblutung', desc_en:'Heart, cholesterol, circulation', goals:[G+'fuer-herz-kreislauf',G+'fuer-den-cholesterinspiegel',G+'fuer-die-durchblutung']},
    {key:'gelenke', icon:'🦴', label:'Gelenke & Beweglichkeit', label_en:'Joints & mobility', desc:'Gelenke & Knochen', desc_en:'Joints & bones', goals:[G+'fuer-die-gelenke',G+'fuer-die-knochen']},
    {key:'haut', icon:'✨', label:'Haut, Haare & Augen', label_en:'Skin, hair & eyes', desc:'Schönheit von innen', desc_en:'Beauty from within', goals:[G+'fuer-haut-haare-naegel',G+'fuer-straffe-haut',G+'gegen-muede-augen']},
    {key:'speziell', icon:'👤', label:'Speziell für dich', label_en:'Just for you', desc:'Frauen, Wechseljahre, Männer, ab 60, vegan', desc_en:'Women, menopause, men, 60+, vegan', goals:[G+'fuer-frauen-ab-40',G+'fuer-die-wechseljahre',G+'fuer-maenner',G+'ab-60',G+'fuer-veganer']}
  ];
  THEMES.forEach(function(th){ th.goals = th.goals.filter(function(s){ return BYSLUG[s]; }); });
  // order themes by demand (sum of customer reviews across their products); personas pinned last
  (function(){
    function demand(th){ return th.goals.reduce(function(s,slug){ var g=BYSLUG[slug]; return s + (g ? g.products.reduce(function(a,p){ return a+(p.rcount||0); },0) : 0); }, 0); }
    var pinned = THEMES.filter(function(th){ return th.label==='Speziell für dich'; });
    var rest = THEMES.filter(function(th){ return th.label!=='Speziell für dich'; });
    rest.sort(function(a,b){ return demand(b)-demand(a); });
    THEMES = rest.concat(pinned);
  })();
  function goalCap(){ return Math.min(3, (state.theme!=null && THEMES[state.theme] ? THEMES[state.theme].goals.length : 3)); }

  // ---- honest intake-timing plan (only well-established, uncontested rules; else "flexible") ----
  var TIMING = {
    'vitamin-d3k2':'meal', 'scheunengut-astaxanthin-12mg-120stk':'meal', 'coenzym-q10':'meal', 'curcumin-komplex-95-bio-kurkuma':'meal',
    'melatonin-magnesium-tabletten-i-365-stuck-i-scheunengut':'evening', 'innere-balance-johanniskraut-baldrian-passionsblume-kapseln-i-120-kapseln-i-scheunengut':'evening', 'ashwagandha-markenrohstoff-withanolide':'evening',
    'eisenbisglycinat-naturliches-vitamin-c':'morning'
  };
  var TIMEMETA = { morning:{i:'☀️',l:t('Morgens','Morning')}, meal:{i:'🍽️',l:t('Zur Mahlzeit','With a meal')}, evening:{i:'🌙',l:t('Abends','Evening')}, flex:{i:'⏱️',l:t('Flexibel','Flexible')} };
  function shortName(tt){ tt=(tt||'').replace(/\s+/g,' ').trim(); return tt.length>36 ? tt.slice(0,34)+'…' : tt; }
  function renderPlan(){
    var el=document.getElementById('sgpf-plan'); if(!el) return;
    var items=Object.keys(state.stack).map(function(h){return state.stack[h];});
    if(!items.length){ el.innerHTML=''; return; }
    var groups={morning:[],meal:[],evening:[],flex:[]};
    items.forEach(function(p){ (groups[TIMING[p.h]||'flex']).push(p); });
    var rows='';
    ['morning','meal','evening','flex'].forEach(function(k){
      if(!groups[k].length) return;
      rows+='<div class="sgpf__planrow"><span class="sgpf__plani" aria-hidden="true">'+TIMEMETA[k].i+'</span><span class="sgpf__planl">'+TIMEMETA[k].l+'</span><span class="sgpf__planp">'+groups[k].map(function(p){return esc(shortName(p.title));}).join(' · ')+'</span></div>';
    });
    el.innerHTML='<div class="sgpf__planhd">💡 '+t('So nimmst du deine Kombi ein','How to take your selection')+'</div>'+rows+'<div class="sgpf__plannote">'+t('Grobe Orientierung – die genaue Einnahme steht auf dem Produkt bzw. im Ratgeber.','Rough guidance – see the product label or guide for exact intake.')+'</div>';
  }

  // ---- Q1: theme cards (broad problem area) ----
  THEMES.forEach(function(th, i){
    if(!th.goals.length) return;
    var b=document.createElement('button');
    b.type='button'; b.className='sgpf__theme'; b.setAttribute('data-ti', i); b.setAttribute('role','listitem');
    b.innerHTML='<span class="sgpf__thico" aria-hidden="true">'+th.icon+'</span><span class="sgpf__thtx"><b>'+esc(EN?th.label_en:th.label)+'</b><small>'+esc(EN?th.desc_en:th.desc)+'</small></span>';
    b.addEventListener('click', function(){ pickTheme(i); });
    themesWrap.appendChild(b);
  });
  function pickTheme(i, noScroll){
    state.theme=i; state.goals=[];
    var th=THEMES[i];
    Array.prototype.forEach.call(themesWrap.children, function(b){ b.classList.toggle('is-sel', b.getAttribute('data-ti')===String(i)); });
    track('theme', {theme: th.label});
    if(th.goals.length===1){ state.goals=[th.goals[0]]; state.cameFrom=1; go(3, noScroll); return; }   // unambiguous → skip Q2
    subWrap.innerHTML='';
    subH.textContent=(EN?th.label_en:th.label)+' – '+t('was genau?','what exactly?');
    th.goals.forEach(function(slug){
      var g=BYSLUG[slug]; if(!g) return;
      var c=document.createElement('button');
      c.type='button'; c.className='sgpf__chip'; c.setAttribute('data-slug',slug); c.setAttribute('role','listitem');
      c.innerHTML='<span class="sgpf__cchk">✓</span><span class="sgpf__cico" aria-hidden="true">'+g.icon+'</span><span class="sgpf__clab">'+esc(g.label)+'</span>';
      c.addEventListener('click', function(){ toggleGoal(slug, c); });
      subWrap.appendChild(c);
    });
    updateSubCount(); state.cameFrom=2; go(2, noScroll);
  }

  // ---- Q2: sub-goal multi-select ----
  function toggleGoal(slug, btn){
    var i=state.goals.indexOf(slug), cap=goalCap();
    if(i>-1){ state.goals.splice(i,1); btn.classList.remove('is-sel'); }
    else { if(state.goals.length>=cap) return; if(state.goals.length===0) track('start',{}); state.goals.push(slug); btn.classList.add('is-sel'); }
    updateSubCount();
  }
  function updateSubCount(){
    var n=state.goals.length, cap=goalCap();
    Array.prototype.forEach.call(subWrap.children, function(b){ b.classList.toggle('is-dis', n>=cap && !b.classList.contains('is-sel')); });
    countEl.innerHTML='<b>'+n+'</b> / '+cap+' '+t('gewählt','selected');
    nextBtn.disabled = n===0;
  }

  // ---- Q3: preference ----
  Array.prototype.forEach.call(root.querySelectorAll('.sgpf__pref'), function(p){
    p.addEventListener('click', function(){ state.pref=p.getAttribute('data-prio'); track('pref',{pref:state.pref}); buildResult(); go(4); });
  });

  // ---- navigation ----
  nextBtn.addEventListener('click', function(){ if(state.goals.length){ track('goals',{goals:state.goals.join(','),count:state.goals.length}); go(3); } });
  var quickBtn=document.getElementById('sgpf-quickstart');
  if(quickBtn) quickBtn.addEventListener('click', function(){
    state.theme=null; state.goals=PRESET.filter(function(s){return BYSLUG[s];}).slice(0,3); state.pref='quality';
    track('quickstart',{goals:state.goals.join(',')}); buildResult(); go(4);
  });
  Array.prototype.forEach.call(root.querySelectorAll('[data-back]'), function(b){
    b.addEventListener('click', function(){ var tgt=parseInt(b.getAttribute('data-back')); if(tgt===2 && state.cameFrom===1) tgt=1; go(tgt); });
  });
  document.getElementById('sgpf-restart').addEventListener('click', function(){
    state={ screen:1, theme:null, goals:[], pref:null, stack:{}, wasFree:false, cameFrom:1, veganOnly:false };
    Array.prototype.forEach.call(themesWrap.children, function(b){ b.classList.remove('is-sel'); });
    subWrap.innerHTML='';
    root.classList.remove('is-campaign');   // leave campaign mode → full finder
    var h1=root.querySelector('.sgpf__h1'), lead=root.querySelector('.sgpf__lead');
    if(h1&&ORIG_H1) h1.textContent=ORIG_H1; if(lead&&ORIG_LEAD) lead.textContent=ORIG_LEAD;
    var co=document.getElementById('sgpf-checkout'); if(co) co.hidden=true;
    go(1);
  });

  // ---- funnel tracking: checkout click (last step) ----
  var checkoutLink=document.getElementById('sgpf-checkout');
  if(checkoutLink) checkoutLink.addEventListener('click', function(){ track('checkout', {}); });

  // ---- vegan filter (data honest: all vegan except glucosamine/chondroitin) ----
  var veganBtn=document.getElementById('sgpf-vegan');
  if(veganBtn) veganBtn.addEventListener('click', function(){
    state.veganOnly=!state.veganOnly;
    track('vegan', {on:state.veganOnly});
    buildResult();
  });

  var STEPLBL={ 1:t('Ziel','Goal'), 2:t('Genauer','Details'), 3:t('Vorliebe','Priority'), 4:t('Deine Kombi','Your selection') };
  function go(n, noScroll){
    state.screen=n;
    for(var k in screens){ screens[k].classList.toggle('is-active', String(n)===k); }
    progfill.style.width = (n===1?25:n===2?50:n===3?75:100)+'%';
    stepn.textContent = (n<4?(n+'/3 · '):'✓ ')+STEPLBL[n];
    if(!noScroll) root.querySelector('.sgpf__app').scrollIntoView({behavior: RM?'auto':'smooth', block:'start'});
  }

  // ---- „Oft zusammen genommen" — sichere, sinnvolle Kombi-Paare (AOV) ----
  var GIN='ginseng-kapseln-roter-panax-10-1-extrakt-i-1200mg-je-tagesdosis-piperin-i-deutsche-herstellung-i-scheunengut';
  var AUG='augenvitamine-i-120-kapseln-i-lutein-zeaxanthin-proanthocyanidine-vitamin-a-b-i-deutsche-herstellung-i-scheunengut';
  var ASX='scheunengut-astaxanthin-12mg-120stk', ASH='ashwagandha-markenrohstoff-withanolide';
  var MAG='magnesium-komplex', MAGB='magnesiumbisglycinat', CUR='curcumin-komplex-95-bio-kurkuma', BRO='bromelain-komplex-magensaftresistent';
  var MACA='maca-komplex-tribulus-ginseng-cordyceps', BKOMP='komplex-aus-allen-8-b-vitaminen-bioaktiv-3-co-faktoren-myo-inositiol-betain-und-cholin';
  var SYNERGY = {};
  SYNERGY[MAG]={p:'vitamin-d3k2', de:'Magnesium hilft dem Körper, Vitamin D zu aktivieren – das Basis-Duo für Energie und Knochen.', en:'Magnesium helps activate vitamin D – the base duo for energy and bones.'};
  SYNERGY['vitamin-d3k2']={p:MAG, de:'Vitamin D braucht Magnesium, um aktiv zu werden – zusammen das perfekte Fundament.', en:'Vitamin D needs magnesium to activate – together the perfect foundation.'};
  SYNERGY[ASH]={p:MAGB, de:'Adaptogen trifft Magnesium – die Kombi für ruhige Nerven und tiefen Schlaf.', en:'Adaptogen meets magnesium – the combo for calm nerves and deep sleep.'};
  SYNERGY['bio-ashwagandha']={p:MAGB, de:'Ashwagandha + Magnesium – das sanfte Duo für Anspannung und Schlaf.', en:'Ashwagandha + magnesium – the gentle duo for tension and sleep.'};
  SYNERGY[MAGB]={p:ASH, de:'Magnesium + Ashwagandha – für Muskeln, Nerven und Gelassenheit am Abend.', en:'Magnesium + ashwagandha – for muscles, nerves and evening calm.'};
  SYNERGY['glucosamin-chondroitin-optimiert-mit-vitamin-c']={p:CUR, de:'Knorpel-Bausteine + Curcumin – oft zusammen für geschmeidige Gelenke genommen.', en:'Cartilage blocks + curcumin – often taken together for supple joints.'};
  SYNERGY[CUR]={p:BRO, de:'Curcumin + das Ananas-Enzym Bromelain – ein bewährtes Gelenk-Team.', en:'Curcumin + pineapple enzyme bromelain – a proven joint team.'};
  SYNERGY[BRO]={p:CUR, de:'Bromelain + Curcumin – das Enzym-Kurkuma-Duo für Gelenke und Wohlbefinden.', en:'Bromelain + curcumin – the enzyme-turmeric duo for joints and wellbeing.'};
  SYNERGY['coenzym-q10']={p:ASX, de:'Q10 + Astaxanthin – zwei kraftvolle Zell-Antioxidantien, ideal fürs Herz.', en:'Q10 + astaxanthin – two powerful cellular antioxidants, ideal for the heart.'};
  SYNERGY[ASX]={p:AUG, de:'Astaxanthin + Lutein & Zeaxanthin – zusammen stark für Augen und Haut.', en:'Astaxanthin + lutein & zeaxanthin – together strong for eyes and skin.'};
  SYNERGY[AUG]={p:ASX, de:'Lutein/Zeaxanthin + Astaxanthin – das Rundum-Duo für müde Augen.', en:'Lutein/zeaxanthin + astaxanthin – the all-round duo for tired eyes.'};
  SYNERGY[GIN]={p:MACA, de:'Ginseng + Maca – zwei Wurzeln für Antrieb, Kraft und Ausdauer.', en:'Ginseng + maca – two roots for drive, strength and stamina.'};
  SYNERGY[MACA]={p:GIN, de:'Maca + Ginseng – das Vitalität-Duo für Energie und Männerkraft.', en:'Maca + ginseng – the vitality duo for energy and male strength.'};
  SYNERGY['eisenbisglycinat-naturliches-vitamin-c']={p:BKOMP, de:'Eisen + B-Vitamine (B12 & Folat) – zusammen für Blutbildung und Energie.', en:'Iron + B-vitamins (B12 & folate) – together for blood formation and energy.'};
  SYNERGY['aminosaure-komplex']={p:MAG, de:'Aminosäuren für die Muskeln, Magnesium für Kraft und Regeneration.', en:'Amino acids for muscles, magnesium for strength and recovery.'};
  SYNERGY['elektrolyte-komplex']={p:'aminosaure-komplex', de:'Elektrolyte + Aminosäuren – die Kombi für harte Trainingseinheiten.', en:'Electrolytes + amino acids – the combo for hard training sessions.'};
  SYNERGY['flora-intenso-kulturen-komplex-mit-23-bakterienstammen-100-mrd-kbe-g-i-60-kapseln-i-scheunengut']={p:'bio-gerstengras-kapseln', de:'Kulturen + Gerstengras-Ballaststoffe – Futter für deine guten Darmbakterien.', en:'Cultures + barley grass fibre – food for your good gut bacteria.'};
  SYNERGY['melatonin-magnesium-tabletten-i-365-stuck-i-scheunengut']={p:ASH, de:'Melatonin bringt dich ins Bett, Ashwagandha den Kopf zur Ruhe.', en:'Melatonin gets you to bed, ashwagandha calms the mind.'};
  SYNERGY['shilajit-resin']={p:'coenzym-q10', de:'Shilajit + Q10 – das Duo für Zellenergie und Vitalität.', en:'Shilajit + Q10 – the duo for cellular energy and vitality.'};
  SYNERGY['mumijo-shilajit-kapseln-i-120-stuck-i-scheunengut']={p:'coenzym-q10', de:'Shilajit + Q10 – zusammen für Antrieb und Zellenergie.', en:'Shilajit + Q10 – together for drive and cellular energy.'};
  SYNERGY[BKOMP]={p:MAG, de:'B-Vitamine + Magnesium – das Energie- und Nerven-Duo für den Alltag.', en:'B-vitamins + magnesium – the energy and nerve duo for everyday life.'};
  SYNERGY['scheunengut-lions-mane-1300mg-pro-dosis-i-180-kapseln-hericium-erinaceus-i-deutsche-herstellung']={p:ASH, de:'Lion’s Mane für den Fokus, Ashwagandha für die innere Ruhe.', en:'Lion’s mane for focus, ashwagandha for inner calm.'};
  SYNERGY['scheunengut-resveratrol-i-500mg-pro-kapsel-i-deutsches-produkt']={p:'coenzym-q10', de:'Resveratrol + Q10 – zwei Longevity-Klassiker für gesunde Zellen.', en:'Resveratrol + Q10 – two longevity classics for healthy cells.'};
  SYNERGY['cordyceps-sinensis-cs-4-extrakt-ideal-1400mg-tagesdosis-i-deutsche-herstellung-i-scheunengu']={p:'reishi-kapseln-vegan-ideal-1950mg-extrakt-pro-tagesdosis-i-deutsche-herstellung-i-scheunengut', de:'Cordyceps für Ausdauer, Reishi für die Abwehr – das Vitalpilz-Team.', en:'Cordyceps for stamina, reishi for defence – the vitality-mushroom team.'};
  function buildCombo(cands){
    for(var i=0;i<cands.length;i++){
      var base=cands[i]; if(!base) continue;
      var syn=SYNERGY[base.h]; if(!syn) continue;
      var partner=PBYH[syn.p];
      if(!partner || !partner.avail || state.stack[partner.h]) continue;                  // schon dabei / ausverkauft
      if(goalblocks.querySelector('.sgpf__pc[data-h="'+partner.h+'"]')) continue;         // schon empfohlen
      var block=document.createElement('div'); block.className='sgpf__gblock sgpf__comboblock';
      var h=document.createElement('div'); h.className='sgpf__gbh sgpf__comboh';
      h.innerHTML='<span aria-hidden="true">🤝</span> '+t('Stärker zusammen','Stronger together');
      block.appendChild(h);
      // WARUM zusammen = echter Kundennutzen der Kombi (prominent, nicht die Ersparnis)
      var why=document.createElement('p'); why.className='sgpf__combowhy';
      why.innerHTML=esc(t(syn.de,syn.en));
      block.appendChild(why);
      var grid=document.createElement('div'); grid.className='sgpf__pcs';
      grid.appendChild(buildCard(partner, -1, true)); block.appendChild(grid);
      // 1-Klick-Bundle: Basis-Produkt + Partner zusammen in die Auswahl (AOV)
      var act=document.createElement('div'); act.className='sgpf__comboact';
      var btn=document.createElement('button'); btn.type='button'; btn.className='sgpf__combobtn';
      btn.innerHTML='➕ '+t('Beide zur Auswahl','Add both');
      btn.addEventListener('click', function(){
        addToStack(base); addToStack(partner); syncCards(); updateSummary(false);
        track('combo_add', {base:base.h, partner:partner.h, value:Math.round((base.price+partner.price)*100)/100});
        btn.classList.add('is-done'); btn.innerHTML='✓ '+t('Beide in der Auswahl','Both selected');
        toast(t('Kombi zur Auswahl hinzugefügt ✓','Combo added to your selection ✓'));
      });
      var hint=document.createElement('span'); hint.className='sgpf__combohint';
      hint.innerHTML='💚 '+t('spart mehr & bringt dich näher an den Gratis-Versand','saves more & gets you closer to free shipping');
      act.appendChild(btn); act.appendChild(hint); block.appendChild(act);
      return block;
    }
    return null;
  }

  // ---- STEP 3: build the personalized stack ----
  function sortProducts(list){
    var arr = list.filter(function(p){return p.avail;});
    if(state.pref==='price') arr.sort(function(a,b){return a.price-b.price;});
    else if(state.pref==='natural') arr.sort(function(a,b){return (b.bot?1:0)-(a.bot?1:0);});
    return arr;
  }
  var capSeen=false, capSicht=false, capFt=null;
  function capToken(){ if(capFt!==null) return; capFt=false;
    fetch('https://data.scheunengut.de/mail/form-token').then(function(r){return r.json();}).then(function(d){ if(d&&d.t) capFt=d; }).catch(function(){});
  }
  function buildCapture(best){
    var wrap=document.createElement('div');
    var done=false; try{ done=localStorage.getItem('sgm_nl_done')==='1'; }catch(e){}
    if(done) return wrap;
    capToken();
    if(!capSeen){ capSeen=true; try{ fetch('https://data.scheunengut.de/mail/form-view',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({slug:'finder',mode:'result'})}); }catch(e){} }
    /* 24.09.2026 (Inhaber-Entscheid *Erst messen*): die Zeile oben zaehlt das RENDERN der Ergebnisseite. Das Feld
       steht nach allen Empfehlungen, vor dem Verzeichnis, und wird seltener gesehen. finder@sicht zaehlt einmal
       je Aufruf, sobald mindestens die Haelfte des Felds im Bild ist. Die Zeile finder zaehlt weiter nur die
       gerenderten Ergebnisse. finder@sicht ist ein Diagnose-Zaehler wie popup@p_TYP: er zaehlt denselben Besuch
       ein ZWEITES Mal. Wer Sichtkontakte je Flaeche ueber alle Unter-Slugs summiert, zaehlt ihn doppelt; der
       Phantom-Ausloeser-Check nimmt @sicht seit H23 (24.09.) ausdruecklich aus. */
    if(!capSicht && 'IntersectionObserver' in window){
      try{
        var capIo=new IntersectionObserver(function(es){
          es.forEach(function(e){
            if(capSicht || !e.isIntersecting || e.intersectionRatio<0.5) return;
            capSicht=true; capIo.disconnect();
            try{ fetch('https://data.scheunengut.de/mail/form-view',{method:'POST',headers:{'Content-Type':'application/json'},keepalive:true,body:JSON.stringify({slug:'finder@sicht',mode:'result'})}); }catch(x){}
          });
        },{threshold:[0.5]});
        capIo.observe(wrap);
      }catch(e){}
    }
    wrap.style.cssText='margin:26px 0 6px;background:#1c4029;border-radius:16px;padding:22px 20px;color:#f3ecd9';
    wrap.innerHTML=
      '<div style="font-size:.72rem;letter-spacing:.14em;text-transform:uppercase;font-weight:700;color:#e2cd92;margin-bottom:6px">'+t('Deine Kombi festhalten','Save your selection')+'</div>'+
      '<div style="font-family:Georgia,serif;font-size:1.25rem;line-height:1.3;color:#fff;margin-bottom:6px">'+t('Wir merken uns deine Auswahl \u2014 plus 15% ab 75 \u20ac zum Start','We will remember your selection \u2014 plus 15% from 75 \u20ac to start')+'</div>'+
      '<p style="margin:0 0 12px;font-size:.92rem;line-height:1.55;color:#e8e0cb">'+t('Dein Willkommensvorteil f\u00fcr die erste Bestellung \u2014 und Empfehlungen, die zu deinen Zielen passen. Keine Mail-Flut \u2014 versprochen.','Your welcome benefit for the first order \u2014 and recommendations that match your goals. No email flood \u2014 promised.')+'</p>'+
      '<form style="display:flex;gap:8px;flex-wrap:wrap"><input type="email" required autocomplete="email" inputmode="email" autocapitalize="none" autocorrect="off" spellcheck="false" placeholder="'+t('Deine E-Mail-Adresse','Your email address')+'" style="flex:1;min-width:200px;padding:12px 14px;border-radius:10px;border:1px solid rgba(226,205,146,.4);background:#fff;color:#20301c;font-size:16px"><button type="submit" style="background:linear-gradient(145deg,#e0c98f,#c6a962);color:#1c2a18;font-weight:700;padding:12px 18px;border:0;border-radius:10px;cursor:pointer;white-space:nowrap;font-size:.92rem">'+t('Merken + 15% sichern','Save + get 15%')+'</button></form>'+
      '<div data-cap-msg style="display:none;margin-top:10px;font-size:.9rem;font-weight:600"></div>'+
      '<p style="margin:.65rem 0 0;font-size:.74rem;color:#b9ae90">'+t('Kostenlos, jederzeit abbestellbar. Best\u00e4tigung per E-Mail (Double-Opt-in).','Free, unsubscribe anytime. Confirmation by email (double opt-in).')+'</p>';
    var f=wrap.querySelector('form'),em=wrap.querySelector('input'),bt=wrap.querySelector('button'),mg=wrap.querySelector('[data-cap-msg]');
    f.addEventListener('submit',function(ev){
      ev.preventDefault();
      var mail=(em.value||'').trim();
      if(!mail||mail.indexOf('@')<1){ mg.style.display='block'; mg.style.color='#f0c9a8'; mg.textContent=t('Bitte gib eine g\u00fcltige E-Mail-Adresse ein.','Please enter a valid email address.'); return; }
      bt.disabled=true; var ot=bt.textContent; bt.textContent='\u2026';
      Promise.race([
        fetch('https://data.scheunengut.de/mail/subscribe',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email:mail,source:'finder',form_slug:'finder',tier:'15',ft_t:(capFt&&capFt.t)||undefined,ft_s:(capFt&&capFt.s)||undefined,attrs:{finder_goals:state.goals.join(','),finder_pref:state.pref,finder_top:(best&&best.h)||''}})}),
        new Promise(function(_,rej){ setTimeout(function(){ rej(new Error('timeout')); },10000); })
      ]).then(function(r){ return r.json(); }).then(function(d){
        if(d&&d.ok){
          try{ localStorage.setItem('sgm_nl_done','1'); }catch(e){}
          f.style.display='none'; mg.style.display='block'; mg.style.color='#bfe0cb';
          mg.textContent=(d.status==='already_confirmed')?t('Du bist schon angemeldet \u2713','You are already subscribed \u2713'):t('Fast geschafft! Best\u00e4tige kurz die E-Mail, die gerade zu dir unterwegs ist.','Almost there! Please confirm the email that is on its way to you.');
        } else { throw new Error('subscribe'); }
      }).catch(function(){ bt.disabled=false; bt.textContent=ot; mg.style.display='block'; mg.style.color='#f0c9a8'; mg.textContent=t('Das hat nicht geklappt \u2014 bitte versuch es gleich noch einmal.','That did not work \u2014 please try again.'); });
    });
    return wrap;
  }
  function buildResult(){
    state.stack = {};
    goalblocks.innerHTML = '';
    var chosen = state.goals.map(function(s){return BYSLUG[s];});
    // header
    var names = chosen.map(function(g){return g.label;});
    rtitle.textContent = t('✨ Deine persönliche Kombi','✨ Your personal selection');
    var prefTxt = {quality:t('beste Qualität','best quality'),price:t('Preis-Leistung','best value'),natural:t('sanft & pflanzlich','gentle & plant-based')}[state.pref];
    rsub.innerHTML = t('Für ','For ')+esc(names.join(', '))+' · '+t('sortiert nach ','sorted by ')+esc(prefTxt)+'. <span class="sgpf__matchnote">'+t('Der Match-Wert kombiniert Ziel-Relevanz, deine Priorität & Kundenbewertungen.','The match score combines goal relevance, your priority & customer ratings.')+'</span>';
    if(veganBtn){ veganBtn.setAttribute('aria-pressed', state.veganOnly?'true':'false'); veganBtn.classList.toggle('is-on', state.veganOnly); }
    // pass 1: score each goal's available products, pre-select the top per goal
    var perGoal=[];
    chosen.forEach(function(g){
      var avail = g.products.filter(function(p){ return p.avail && (!state.veganOnly || p.veg); });
      if(!avail.length) return;
      var prices = avail.map(function(p){ return p.price; });
      var pmin = Math.min.apply(null, prices), pmax = Math.max.apply(null, prices);
      avail.forEach(function(p, ci){ p.__match = matchScore(p, ci, pmin, pmax); });
      var sorted = avail.slice().sort(function(a,b){ return b.__match - a.__match; });
      perGoal.push({ g:g, list: sorted.slice(0,2) });
      if(sorted[0]) addToStack(sorted[0]);
    });
    // ⭐ single clear top recommendation (answers "which one should I take?")
    var best=null, bestG=null;
    perGoal.forEach(function(pg){ if(pg.list[0] && (!best || pg.list[0].__match>best.__match)){ best=pg.list[0]; bestG=pg.g; } });
    var totalShown = perGoal.reduce(function(s,pg){ return s+pg.list.length; }, 0);
    var useSpot = best && totalShown>=2;
    if(useSpot) goalblocks.appendChild(buildSpotlight(best, bestG.label, bestG.icon, bestG.slug));
    // pass 2: goal blocks (exclude the spotlight product to avoid duplication)
    perGoal.forEach(function(pg){
      var list = pg.list.filter(function(p){ return !(useSpot && p.h===best.h); });
      if(!list.length) return;
      var g=pg.g;
      var block=document.createElement('div'); block.className='sgpf__gblock';
      var h=document.createElement('div'); h.className='sgpf__gbh';
      h.innerHTML='<span aria-hidden="true">'+g.icon+'</span> '+esc(g.label)+'<a href="'+g.link+'">'+t('Ratgeber','Guide')+' →</a>';
      block.appendChild(h);
      var grid=document.createElement('div'); grid.className='sgpf__pcs';
      list.forEach(function(p){ grid.appendChild(buildCard(p, p===pg.list[0]?0:1, false, g.label, g.icon, g.slug)); });
      block.appendChild(grid);
      goalblocks.appendChild(block);
    });
    // „Oft zusammen genommen": passende Kombi zu einer der Empfehlungen (AOV, opt-in)
    var comboCands=[best]; perGoal.forEach(function(pg){ pg.list.forEach(function(p){ comboCands.push(p); }); });
    var combo=buildCombo(comboCands); if(combo) goalblocks.appendChild(combo);
    // cross-sell: one popular base supplement not already recommended (AOV, opt-in)
    var shown={}; Array.prototype.forEach.call(goalblocks.querySelectorAll('.sgpf__pc'), function(c){ shown[c.getAttribute('data-h')]=1; });
    var BASICS=['vitamin-d3k2','magnesium-komplex','coenzym-q10','curcumin-komplex-95-bio-kurkuma'];
    for(var bx=0; bx<BASICS.length; bx++){ var ap=PBYH[BASICS[bx]]; if(ap && ap.avail && !shown[ap.h]){ goalblocks.appendChild(buildAddon(ap)); break; } }
    // honest safety/trust note for health-sensitive goals (never a medical claim)
    var SENSITIVE={'beste-supplements-fuer-die-schilddruese':1,'beste-supplements-fuer-herz-kreislauf':1,'beste-supplements-fuer-die-blutbildung':1,'beste-supplements-fuer-die-durchblutung':1,'beste-supplements-fuer-die-blase':1,'beste-supplements-fuer-frauen-ab-40':1,'beste-supplements-ab-60':1};
    if(state.goals.some(function(s){ return SENSITIVE[s]; })){
      var note=document.createElement('div'); note.className='sgpf__safenote';
      note.innerHTML='<span aria-hidden="true">ℹ️</span> '+t('Gut zu wissen: Bei bestehenden Erkrankungen, in Schwangerschaft oder Stillzeit oder bei der Einnahme von Medikamenten besprich Nahrungsergänzung bitte vorab mit deiner Ärztin oder deinem Arzt.','Good to know: if you have existing conditions, are pregnant or breastfeeding, or take medication, please discuss supplements with your doctor first.');
      goalblocks.appendChild(note);
    }
    // reflect pre-selected state on buttons/cards
    syncCards();
    updateSummary(true);
    // Ergebnis-Capture (08.08.): Kombi merken + Newsletter — hoechste Kaufintention der Site.
    // Ehrlich: attrs (Ziele+Top-Produkt) werden am Kontakt gespeichert = "wir merken uns deine Auswahl" ist wahr.
    try{ goalblocks.appendChild(buildCapture(best)); }catch(e){}
    track('result_view', {goals:state.goals.join(','), pref:state.pref});
    try{ if(history.replaceState){ var params; try{ params=new URLSearchParams(location.search); }catch(e){ params=new URLSearchParams(); } params.set('ziele', state.goals.map(function(s){return s.replace('beste-supplements-','');}).join(',')); params.set('prio', state.pref); history.replaceState(null,'',location.pathname+'?'+params.toString()); } }catch(e){}   // UTM/campaign params preserved
  }
  function buildAddon(p){
    var block=document.createElement('div'); block.className='sgpf__gblock sgpf__addonblock';
    var h=document.createElement('div'); h.className='sgpf__gbh sgpf__addonh';
    h.innerHTML='<span aria-hidden="true">🧩</span> '+t('Beliebte Basis – passt zu fast jedem Ziel','Popular base – fits almost any goal');
    block.appendChild(h);
    var grid=document.createElement('div'); grid.className='sgpf__pcs';
    grid.appendChild(buildCard(p, -1, true));
    block.appendChild(grid);
    return block;
  }

  function buildSpotlight(p, goalLabel, goalIcon, goalSlug){
    var cmp = (p.compare>p.price)?'<span class="sgpf__pccmp">'+eur(p.compare)+'</span>':'';
    var save = (p.compare>p.price)?'<span class="sgpf__spotsave">'+t('du sparst ','you save ')+eur(p.compare-p.price)+'</span>':'';
    var wrap=document.createElement('div'); wrap.className='sgpf__spotlight';
    wrap.innerHTML=
      '<div class="sgpf__spothd">⭐ '+t('Deine Top-Empfehlung','Your top pick')+' <span>'+t('– damit würden wir starten','– we’d start here')+'</span></div>'+
      '<div class="sgpf__spotcard sgpf__pc" data-h="'+p.h+'">'+
        '<a class="sgpf__spotimg" href="'+PFX+'/products/'+p.h+'"><img src="'+p.img+'" alt="'+esc(p.title)+'" loading="lazy" width="220" height="220"></a>'+
        '<div class="sgpf__spotinfo">'+
          '<div class="sgpf__pcfit">'+(goalLabel?fitRow(p, goalLabel, goalIcon):matchPill(p))+'</div>'+
          '<h3 class="sgpf__pct sgpf__spottitle"><a href="'+PFX+'/products/'+p.h+'">'+esc(p.title)+'</a></h3>'+
          starRow(p)+
          '<p class="sgpf__nutzen sgpf__spotnutzen">'+esc(goalNutzen(p, goalSlug))+'</p>'+
          warumRow(p)+
          '<div class="sgpf__pcprow"><span class="sgpf__pcprice sgpf__spotprice">'+eur(p.price)+'</span>'+cmp+save+'</div>'+
          '<button type="button" class="sgpf__toggle sgpf__spottoggle" data-h="'+p.h+'"></button>'+
        '</div>'+
      '</div>';
    wrap.querySelector('.sgpf__toggle').addEventListener('click', function(){ toggleStack(p); });
    return wrap;
  }

  function matchPill(p){
    var rt = p.rating ? p.rating.toFixed(2).replace('.',',') : '', m=p.__match;
    var mTitle = t('Match '+m+' % – aus Ziel-Relevanz, deiner Priorität ('+prefLabel()+') und Kundenbewertung'+(rt?' '+rt+'★':''),
                   'Match '+m+'% – from goal relevance, your priority ('+prefLabel()+') and rating'+(rt?' '+rt+'★':''));
    return '<span class="sgpf__pcmatch" title="'+esc(mTitle)+'"><b>'+m+'%</b> '+t('passt','match')+'</span>';
  }
  function fitRow(p, goalLabel, goalIcon){
    return '<span class="sgpf__pcgoal"><span aria-hidden="true">'+(goalIcon||'🎯')+'</span> '+t('Für','For')+' '+esc(goalLabel)+'</span>'+matchPill(p);
  }
  function starRow(p){
    if(!p.rating) return '';
    var rt=p.rating.toFixed(2).replace('.',','), w=(p.rating/5*100).toFixed(1);
    return '<div class="sgpf__rate"><span class="sgpf__stars"><i style="width:'+w+'%"></i></span><span class="sgpf__rn">'+rt+'</span>'+(p.rcount?'<span class="sgpf__rc">('+p.rcount+')</span>':'')+'</div>';
  }
  function warumRow(p){ return p.warum ? '<p class="sgpf__warum"><b>'+t('Warum dieses:','Why this one:')+'</b> '+esc(p.warum)+'</p>' : ''; }
  // ziel-spezifischer Nutzen (Matrix SGPF_NZ[handle][ziel] = {n:de,e:en}); Fallback = primärer Nutzen
  function goalNutzen(p, slug){
    var M = window.SGPF_NZ; if(M && slug && M[p.h] && M[p.h][slug]){ var x=M[p.h][slug]; var v=t(x.n, x.e||x.n); if(v) return v; }
    return p.nutzen;
  }

  function buildCard(p, idx, addon, goalLabel, goalIcon, goalSlug){
    var badge='';
    if(idx===0) badge='<span class="sgpf__badge sgpf__badge--top">'+t('★ Beste Wahl','★ Best match')+'</span>';
    else if(!addon && p.rcount>=400) badge='<span class="sgpf__badge sgpf__badge--pop">'+t('Bestseller','Bestseller')+'</span>';
    var fit = addon ? '<span class="sgpf__pcgoal sgpf__pcgoal--add"><span aria-hidden="true">🧩</span> '+t('Sinnvolle Ergänzung','Smart add-on')+'</span>'
                    : (goalLabel ? fitRow(p, goalLabel, goalIcon) : matchPill(p));
    var cmp = (p.compare>p.price)?'<span class="sgpf__pccmp">'+eur(p.compare)+'</span>':'';
    var el = document.createElement('article');
    el.className='sgpf__pc'; el.setAttribute('data-h',p.h);
    el.innerHTML =
      '<a class="sgpf__pcimg" href="'+PFX+'/products/'+p.h+'">'+badge+'<img src="'+p.img+'" alt="'+esc(p.title)+'" loading="lazy" width="240" height="240"></a>'+
      '<div class="sgpf__pcb">'+
        '<div class="sgpf__pcfit">'+fit+'</div>'+
        '<h3 class="sgpf__pct"><a href="'+PFX+'/products/'+p.h+'">'+esc(p.title)+'</a></h3>'+
        starRow(p)+
        '<p class="sgpf__nutzen">'+esc(goalNutzen(p, goalSlug))+'</p>'+
        warumRow(p)+
        '<div class="sgpf__pcprow"><span class="sgpf__pcprice">'+eur(p.price)+'</span>'+cmp+'</div>'+
        '<button type="button" class="sgpf__toggle" data-h="'+p.h+'"></button>'+
      '</div>';
    el.querySelector('.sgpf__toggle').addEventListener('click', function(){ toggleStack(p); });
    return el;
  }

  function addToStack(p){ if(p.vid) state.stack[p.h]=p; }
  function toggleStack(p){
    if(state.stack[p.h]) delete state.stack[p.h];
    else addToStack(p);
    syncCards(); updateSummary(false);
  }
  function syncCards(){
    Array.prototype.forEach.call(goalblocks.querySelectorAll('.sgpf__pc'), function(card){
      var h = card.getAttribute('data-h'), inStack = !!state.stack[h];
      card.classList.toggle('is-in', inStack);
      var btn = card.querySelector('.sgpf__toggle');
      btn.classList.toggle('is-in', inStack);
      btn.textContent = inStack ? ('✓ '+t('Ausgewählt','Selected')) : ('+ '+t('Hinzufügen','Add'));
    });
  }

  function updateSummary(instant){
    var items = Object.keys(state.stack).map(function(h){return state.stack[h];});
    var total=0, save=0;
    items.forEach(function(p){ total+=p.price; if(p.compare>p.price) save+=(p.compare-p.price); });
    stackCount.textContent = items.length+' '+(items.length===1?t('Produkt','product'):t('Produkte','products'));
    if(instant) stackTotal.textContent = eur(total); else countTo(stackTotal, total);
    if(save>0.001){ stackSave.textContent = t('du sparst ','you save ')+eur(save); stackSave.style.display=''; }
    else stackSave.style.display='none';
    if(!instant) bump(stackTotal);
    // free shipping bar
    var pct = Math.min(100, total/FREESHIP*100);
    shipFill.style.width = pct+'%';
    var free = total>=FREESHIP;
    if(free){ shipMsg.textContent='🎉 '+t('Gratis-Versand freigeschaltet!','Free shipping unlocked!'); shipMsg.classList.add('free'); }
    else { shipMsg.textContent = t('Noch ','Only ')+eur(FREESHIP-total)+t(' bis Gratis-Versand 🚚',' to free shipping 🚚'); shipMsg.classList.remove('free'); }
    if(free && !state.wasFree && !instant){ shipMsg.classList.remove('pop'); void shipMsg.offsetWidth; shipMsg.classList.add('pop'); confetti(); }
    state.wasFree = free;
    addAll.disabled = items.length===0;
    addAll.textContent = items.length>1 ? (t('Alle in den Warenkorb','Add all to cart')+' ('+items.length+')') : t('In den Warenkorb','Add to cart');
    renderPlan();
  }
  function bump(el){ el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }

  /* 24.09.2026 (Inhaber-Entscheid *Erst messen*): ob der Finder VERKAUFT, war nicht messbar — seine Warenkoerbe
     trugen keine Kennung (nur GA4). Jetzt setzt er das Warenkorb-Attribut sg_quelle=produktfinder, dazu den Weg
     (korb = *In den Warenkorb* im Finder, produkt = Klick auf eine Empfehlungskarte, liste = Klick auf ein
     Produkt im Verzeichnis *Alle Ziele im Ueberblick*, Karte oder *Auch passend*) und die Ziele: gewaehlt, beim
     Verzeichnis das Ziel des Abschnitts. Das Verzeichnis wird ueber seinen ABSCHNITT erkannt (id g-<ziel>),
     nicht ueber eine Kartenklasse: es traegt zwei Linkarten (77 Karten, 131 Chips am 24.09.), und eine dritte
     waere ohne Aenderung hier abgedeckt.
     Die Attribute stehen spaeter an der Bestellung. Dasselbe Verfahren wie der Produktkasten im Ratgeber
     (sg_quelle=blog_produkt): beim Kartenklick wartet die Navigation hoechstens 600 ms auf das Attribut,
     Klicks mit Zusatztaste oder in einen neuen Tab laufen unveraendert. */
  function finderKennung(weg, zielListe){
    try{
      var ziele=(zielListe||state.goals||[]).map(function(s){return String(s).replace('beste-supplements-','');}).join(',').slice(0,120);
      return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},keepalive:true,
        body:JSON.stringify({attributes:{sg_quelle:'produktfinder',sg_finder:weg,sg_finder_ziele:ziele}})}).catch(function(){});
    }catch(e){ return Promise.resolve(); }
  }
  root.addEventListener('click', function(ev){
    var a=(ev.target && ev.target.closest) ? ev.target.closest('a[href^="/products/"]') : null;
    if(!a || !root.contains(a)) return;
    var karte=a.closest('.sgpf__pc'), abschnitt=karte ? null : a.closest('[id^="g-beste-supplements-"]');
    if(!karte && !abschnitt) return;
    var kennung=finderKennung(karte ? 'produkt' : 'liste', abschnitt ? [abschnitt.id.slice(2)] : null);
    if(ev.defaultPrevented || ev.button!==0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || a.target==='_blank') return;
    ev.preventDefault();
    var ziel=a.href, fertig=false;
    var weiter=function(){ if(fertig) return; fertig=true; location.href=ziel; };
    kennung.then(weiter, weiter);
    setTimeout(weiter, 600);
  });

  // ---- add all to cart ----
  addAll.addEventListener('click', function(){
    var items = Object.keys(state.stack).map(function(h){return state.stack[h];}).filter(function(p){return p.vid;});
    if(!items.length) return;
    var value = items.reduce(function(s,p){return s+p.price;}, 0);
    addAll.disabled=true; var o=addAll.textContent; addAll.textContent='…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items.map(function(p){return {id:p.vid,quantity:1};})})})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(){
        trackAddToCart(items, value); confetti(); finderKennung('korb');
        var co=document.getElementById('sgpf-checkout'); if(co) co.hidden=false;   // clear path to checkout
        addAll.classList.add('done'); addAll.textContent='✓ '+t('Im Warenkorb','In cart');
        fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
          document.querySelectorAll('.cart-count,[data-cart-count],.cart-link__count,.cart-count-bubble,.js-cart-count,.header__cart-count').forEach(function(el){el.textContent=c.item_count;});
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
        toast(t(items.length+' Produkte im Warenkorb','Added '+items.length+' products'), '/cart', t('Zum Warenkorb','View cart'));
        setTimeout(function(){ addAll.classList.remove('done'); addAll.disabled=false; addAll.textContent=o; }, 2600);
      })
      .catch(function(){ addAll.disabled=false; addAll.textContent=t('Bitte erneut','Try again'); setTimeout(function(){addAll.textContent=o;},1800); });
  });

  var toastEl;
  function toast(msg, href, linktext){
    if(!toastEl){ toastEl=document.createElement('div'); toastEl.className='sgpf__toast'; document.body.appendChild(toastEl); }
    toastEl.innerHTML = esc(msg) + (href?' <a href="'+href+'">'+esc(linktext)+'</a>':'');
    toastEl.classList.add('show');
    clearTimeout(toastEl.__t); toastEl.__t=setTimeout(function(){ toastEl.classList.remove('show'); }, 4200);
  }

  // ---- deep-link: /pages/produktfinder?ziele=mehr-energie,immunsystem&prio=preis → direkt zum Stack (Ad-Kampagnen) ----
  function normPref(v){ v=(v||'').toLowerCase(); if(v==='price'||v==='preis') return 'price'; if(v==='natural'||v==='pflanzlich'||v==='vegan'||v==='sanft') return 'natural'; if(v==='quality'||v.indexOf('quali')===0) return 'quality'; return null; }
  function resolveGoal(tok){ tok=(tok||'').toLowerCase().trim(); if(!tok) return null; if(BYSLUG[tok]) return tok; if(BYSLUG['beste-supplements-'+tok]) return 'beste-supplements-'+tok; for(var s in BYSLUG){ var suf=s.replace('beste-supplements-',''); if(suf===tok || (tok.length>=4 && s.indexOf(tok)>-1)) return s; } return null; }
  // message-match: rewrite the hero to the ad's promise (biggest ad-conversion / Quality-Score lever)
  function applyLandingHero(head, sub){
    var h1=root.querySelector('.sgpf__h1'), lead=root.querySelector('.sgpf__lead');
    if(h1 && head) h1.textContent = head;
    if(lead && sub) lead.textContent = sub;
    root.classList.add('is-campaign');
  }
  function tryDeepLink(){
    var q; try{ q=new URLSearchParams(location.search); }catch(e){ return false; }
    // (a) specific goals → straight to the result with a message-matched headline
    var gp=q.get('ziele')||q.get('goals')||q.get('goal');
    if(gp){
      var slugs=[]; gp.split(',').forEach(function(tok){ var s=resolveGoal(tok); if(s && slugs.indexOf(s)<0 && slugs.length<MAXGOALS) slugs.push(s); });
      if(slugs.length){
        state.goals=slugs.slice(0,3);
        state.pref=normPref(q.get('prio')||q.get('pref'))||'quality';
        state.veganOnly = (q.get('vegan')==='1'||q.get('vegan')==='true');   // vegan-targeted campaigns
        track('deeplink', {goals:state.goals.join(','), pref:state.pref, vegan:state.veganOnly});
        var g0 = state.goals.length===1 ? BYSLUG[state.goals[0]] : null;
        applyLandingHero(
          (g0 && g0.h2) ? g0.h2 : t('Deine persönliche Supplement-Empfehlung','Your personal supplement recommendation'),
          t('In wenigen Sekunden zu deiner passenden Auswahl – laborgeprüft, echt bewertet, mit Ersparnis.','Your matching selection in seconds – lab-tested, truly rated, with savings.')
        );
        buildResult(); go(4, true);
        return true;
      }
    }
    // (b) broad theme → land on the sub-goal question, headline matched to the theme
    var tk=(q.get('thema')||q.get('theme')||'').toLowerCase().trim();
    if(tk){
      var ti=-1, i;
      for(i=0;i<THEMES.length;i++){ if(THEMES[i].key===tk){ ti=i; break; } }
      if(ti<0){ for(i=0;i<THEMES.length;i++){ if((EN?THEMES[i].label_en:THEMES[i].label).toLowerCase().indexOf(tk)>-1){ ti=i; break; } } }
      if(ti>-1){
        track('deeplink', {theme:THEMES[ti].label});
        applyLandingHero(
          (EN?THEMES[ti].label_en:THEMES[ti].label),
          t('Wähle dein genaues Ziel – wir zeigen dir sofort passende, laborgeprüfte Produkte.','Pick your exact goal – we instantly show matching, lab-tested products.')
        );
        pickTheme(ti, true);
        return true;
      }
    }
    return false;
  }

  track('view', {});   // funnel top: finder loaded
  if(!tryDeepLink()) go(1);

  /* H142 (05.10.2026): die englische Seite verlinkte auf die deutschen Produkt- und Ratgeberseiten, und der Tagespreis stand
     deutsch da. Im Abschnitt selbst ist kein Platz fuer 371 Sprachweichen (Grenze 256 KB fuer Abschnittsdateien), deshalb hier. */
  if(EN){
    [].forEach.call(root.querySelectorAll('a[href^="/products/"],a[href^="/blogs/"],a[href^="/pages/"],a[href^="/cart"]'), function(a){ a.setAttribute('href', '/en'+a.getAttribute('href')); });
    [].forEach.call(root.querySelectorAll('.sgpf__cpd'), function(el){ var m=/Nur\s+([0-9]+,[0-9]{2})\s*\u20ac\s*\/\s*Tag/.exec(el.textContent||''); if(m) el.textContent='Only '+m[1]+' \u20ac / day'; });
  }
  // ---- live stock: ausverkaufte ausblenden + wieder-verfügbare automatisch einblenden (ohne Rebuild) ----
  (function(){
    try{
      fetch(PFX+'/products.json?limit=250', {headers:{Accept:'application/json'}})   /* H142: auf /en mit englischen Titeln */
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(d){
          if(!d || !d.products) return;
          var A={}; d.products.forEach(function(pr){ A[pr.handle] = (pr.variants||[]).some(function(v){ return v.available; }); });
          var changed=false;
          ALLP.forEach(function(p){
            if(Object.prototype.hasOwnProperty.call(A, p.h) && A[p.h] !== p.avail){ p.avail = A[p.h]; changed = true; }
            if(p.el){ p.el.style.display = p.avail ? '' : 'none'; p.el.setAttribute('data-avail', p.avail ? '1' : '0'); }
          });
          /* H142 (05.10.2026): Preis, Streichpreis, Rabatt und Titel folgen dem Shop. Die Karten sind am 13.07. erzeugt
             worden; bis hierher glich das Skript nur die Lieferbarkeit ab. Gefunden: Shilajit-Resin zeigte 15,99 EUR
             (30 g, ausverkauft), der Knopf legt aber die 50-g-Variante zu 22,99 EUR in den Korb. Massgeblich ist deshalb
             die Variante, die der Knopf wirklich nimmt (data-vid). Der Tagespreis gilt fuer den alten Preis und laesst sich
             hier nicht neu rechnen, er wird bei einer Preisaenderung ausgeblendet. */
          var L={}; d.products.forEach(function(pr){ L[pr.handle]=pr; });
          var eur=function(n){ return n.toFixed(2).replace('.',',')+'\u00a0\u20ac'; };
          ALLP.forEach(function(p){
            var pr=L[p.h]; if(!pr) return;
            if(pr.title && pr.title!==p.title){ p.title=pr.title; var ta=p.el&&p.el.querySelector('.sgpf__ptitle a'); if(ta) ta.textContent=pr.title; changed=true; }
            var v=null; (pr.variants||[]).forEach(function(x){ if(String(x.id)===String(p.vid)) v=x; });
            if(!v) return;
            var np=parseFloat(v.price), nc=parseFloat(v.compare_at_price||0);
            if(!(np>0)) return;
            if(!(nc>np)) nc=0;
            var ac=(p.compare>p.price)?p.compare:0;
            if(np===p.price && nc===ac) return;
            p.price=np; p.compare=nc; changed=true;
            if(!p.el) return;
            p.el.setAttribute('data-price',String(np)); p.el.setAttribute('data-compare',nc?String(nc):'');
            var pe=p.el.querySelector('.sgpf__price'); if(pe) pe.textContent=eur(np);
            var ce=p.el.querySelector('.sgpf__compare'); if(ce){ if(nc){ ce.textContent=eur(nc); ce.style.display=''; } else { ce.style.display='none'; } }
            var se=p.el.querySelector('.sgpf__save'); if(se){ if(nc){ se.textContent='-'+Math.round((1-np/nc)*100)+'\u00a0%'; se.style.display=''; } else { se.style.display='none'; } }
            var de=p.el.querySelector('.sgpf__cpd'); if(de) de.style.display='none';
          });
          [].forEach.call(root.querySelectorAll('.sgpf__xchip[data-h]'), function(el){   // cross-Chips im Verzeichnis
            var h=el.getAttribute('data-h'); if(Object.prototype.hasOwnProperty.call(A,h)) el.style.display = A[h] ? '' : 'none';
          });
          if(changed && state.screen===4) buildResult();   // Empfehlungen mit Live-Bestand aktualisieren
        }).catch(function(){});
    }catch(e){}
  })();
})();
